module.exports = __webpack_public_path__ + "static/media/world.082ada96.svg";